import request from './request';
import { getUserEmail } from '../utils/utils';
export var getUserPermission = function getUserPermission(sellerId) {
  var email = getUserEmail();
  return request("https://api.cimpress.io/auth/access-management/v1/principals/" + email + "/permissions/fulfillers/" + sellerId + "/evaluate:price-models", 'GET', null, true, 'none').then(function (res) {
    return res && res.status && res.status === 204;
  }).catch(function (err) {
    return false;
  });
};